import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Drawer  } from 'antd';
import Header from "../../../components/header/Header";
import AvatarDropdown from "../../../components/AvatarDropdown";
import { connect } from "react-redux";
import {init} from "../../../actions/app";
import GlobalLoader from "../../../components/Loaders/GlobalLoader";
import { deleteTokens } from "../../../utils/auth";
import RightPanelDrawer from "../../../components/RightPanelDrawer";
import HeaderLeft from "../../../components/header/HeaderLeft";
import MenuButton from "../../../components/header/MenuButton";
import NotificationsDrawerButton from "../../../components/Notifications/NotificationsDrawerButton";
import NotificationsListWrapper from "../../../components/Notifications/NotificationsListWrapper";
import MenuBanks from "./MenuBanks";
import 'react-toastify/dist/ReactToastify.css';
import "./MenuBanks.scss"
import "./MasterLayout.scss";
import BackToTop from "../../../uikit/BackToTop";
class MasterLayout extends Component {

    state = { 
        visible: false,
        collapsedMenu: true
    };

    componentDidMount() {
        this.props.init().then(() => {
            if (!!this.props.user.role && this.props.user.role !== 'CREDITOR') {

                deleteTokens();
                return window.location.href = '/login';
            }
          });
    }
    
    showDrawer = () => {
        this.setState({
          visible: !this.state.visible,
        });
    };

    handleCollapsedMenu = () => {
        this.setState({
            collapsedMenu: !this.state.collapsedMenu
        });
    }
    
    onClose = () => {
        this.setState({
            visible: false,
        });
    };



    render() {
        const { user } = this.props;
        const { collapsedMenu } = this.state;

        return (
            <div>
                {(!!user.role && user.role === 'CREDITOR') ? (
                    <>
                        <Header >
                            <HeaderLeft>
                                <MenuButton handleCollapsedMenu={this.handleCollapsedMenu} />
                            </HeaderLeft>
                            <NotificationsDrawerButton showDrawer={this.showDrawer}/>
                            <AvatarDropdown />
                        </Header>
                        <div 
                            className="d-flex"
                            style={{ position: 'relative',  overflow: 'hidden' }}
                        >
                            <div className="layout-leftPanel">
                                <MenuBanks />
                            </div>
                            <div className="masterLayout-content">
                                {this.props.children}
                            </div>
                            <RightPanelDrawer 
                                visible={this.state.visible} 
                                onClose={this.onClose}
                                title="Notiser"
                            >
                                <NotificationsListWrapper />
                            </RightPanelDrawer>
                        </div>
                        <GlobalLoader isLoading={this.props.app.showLoader}/>
                        <ToastContainer 
                            autoClose={2000}
                            hideProgressBar
                            position="top-right"
                            limit={4}
                        />
                        <Drawer
                            className="menuDrawer"
                            title="Meny"
                            placement="left"
                            onClick={() => this.setState({collapsedMenu :true})}
                            onClose={() => this.setState({collapsedMenu :true})}
                            visible={!collapsedMenu}
                        >
                            <MenuBanks />
                        </Drawer>
                        <BackToTop />
                    </>
                ) : (
                    <>
                        <div className="roleError">Authority is required</div>
                        <GlobalLoader isLoading={this.props.app.showLoader}/>
                    </>
                )}

                
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        user: store.me.profile,
        app: store.app,
    }
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        init: () => dispatch(init())
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(MasterLayout);